var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4713_18751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.0543 16.0537L31.5893 5.5887C30.7877 4.78703 29.6827 4.33203 28.5343 4.33203H12.9993C10.616 4.33203 8.68768 6.28203 8.68768 8.66536L8.66602 43.332C8.66602 45.7154 10.5943 47.6654 12.9777 47.6654H38.9993C41.3827 47.6654 43.3327 45.7154 43.3327 43.332V19.1304C43.3327 17.982 42.8777 16.877 42.0543 16.0537ZM32.066 32.4987H28.166V38.9987C28.166 40.1904 27.191 41.1654 25.9993 41.1654C24.8077 41.1654 23.8327 40.1904 23.8327 38.9987V32.4987H19.9543C18.9793 32.4987 18.5027 31.3287 19.196 30.657L25.2627 24.612C25.696 24.2004 26.3677 24.2004 26.801 24.612L32.846 30.657C33.496 31.3287 33.0194 32.4987 32.066 32.4987ZM30.3327 19.4987C29.141 19.4987 28.166 18.5237 28.166 17.332V7.58203L40.0827 19.4987H30.3327Z",
    fill: "#4776E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4713_18751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload-file.513a8621f52b07faa3bf560e20e5806d.svg";
export { ForwardRef as ReactComponent };